import { useScope } from "~/hooks/useScope";
import { OrganizationPoliciesAddDetailPage } from "~/pages/organization/policies-add/OrganizationPoliciesAddDetailPage";

export function OrganizationPoliciesAddDetailEntryPage() {
  const { organizationScope } = useScope();
  return organizationScope ? (
    <OrganizationPoliciesAddDetailPage scope={organizationScope} />
  ) : undefined;
}
